// Container QR label (Stage 6, D3): the QR holds the plain container id, with the name, the waste
// code and the last 6 characters printed under it. Same qrcode + printd pattern as
// components/CarLocations/print.js.
import QrCode from "qrcode";
import { Printd } from "printd";
import { labelData } from "./wasteContainer.mjs";

const css = `
  @page { size: A4; }
  body { font: 12px "Lucida Grande", Helvetica, Arial, sans-serif; }
  #container { margin: 10px; display: flex; flex-wrap: wrap; }
  .label { margin: 8px; padding: 8px; width: 180px; border: 1px dashed #999; text-align: center; }
  .label img { display: block; margin: 0 auto; width: 140px; height: 140px; }
  .name { font-size: 14px; font-weight: bold; word-break: break-word; }
  .code { font-size: 16px; font-weight: bold; margin-top: 4px; }
  .short { font-size: 12px; letter-spacing: 1px; margin-top: 2px; }
`;

async function labelElement(container) {
  const data = labelData(container);
  const dataUrl = await QrCode.toDataURL(data.id, { margin: 1 });
  const wrapper = document.createElement("div");
  wrapper.className = "label";
  const image = document.createElement("img");
  image.setAttribute("src", dataUrl);
  const name = document.createElement("div");
  name.className = "name";
  name.textContent = data.name;
  const code = document.createElement("div");
  code.className = "code";
  code.textContent = data.code;
  const short = document.createElement("div");
  short.className = "short";
  short.textContent = data.shortId;
  wrapper.append(image, name, code, short);
  return wrapper;
}

// containers: [{ id, name, waste: { code } }]
export default async function printContainerLabels(containers) {
  const labels = await Promise.all(containers.map(labelElement));
  const content = document.createElement("div");
  content.setAttribute("id", "container");
  labels.forEach((label) => content.appendChild(label));
  new Printd().print(content, [css]);
}
